import { FilePicker } from '@capawesome/capacitor-file-picker'

export default defineNuxtPlugin(() => {
	if (
		typeof window !== 'undefined'
		// In Cypress wollen wir nur den Mock verwenden
		&& !window.Cypress
		&& !window.FilePicker
	) {
		window.FilePicker = FilePicker
	}
	console.debug('Initialized')
})
